import { render, staticRenderFns } from "./EnterMessage.vue?vue&type=template&id=56a33977"
import script from "./EnterMessage.vue?vue&type=script&lang=js"
export * from "./EnterMessage.vue?vue&type=script&lang=js"
import style0 from "./EnterMessage.vue?vue&type=style&index=0&id=56a33977&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports